
import { defineComponent, inject, ref, reactive, computed } from 'vue'
import type { FormInstance, FormRules } from "element-plus";
import sportService from "@/core/services/SportService"
import { errManager, cBoolean } from "@/core/config/Tools";

export default defineComponent({
    props:{
        setting: {
            type: Object,
            required: true,
            default: {}
        },
        item: {
            type: Object,
            required: false,
            default: {}
        }
    },
    setup(props, {emit}) {
        const titleDialog = ref('')
        const gblDialog = inject<any>('gblDialog')
        const gblAction = inject<any>('gblAction')

        const loader = ref(false)
        const ruleFormRef = ref < FormInstance > ()
        const listCategorie = ref([])
        const listStatus = ref([])
        const form = reactive <any>({})
        const rules = reactive < FormRules > ({
            name: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            acronym: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            categorie: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            slug: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            tagform: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            mstatus: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
        })

        const onOpen = () => {
            titleDialog.value = gblAction.value == 'new' ? 'Registrar deporte' : 'Editar deporte'
            listCategorie.value = props.setting.types
            listStatus.value = props.setting.status
        }

        const onOpened = () => {
            if(gblAction.value == 'edit')
                onEdit()
        }

        const onClosed = () => {
            titleDialog.value = ''
            resetForm(ruleFormRef.value)
        }

        const resetForm = (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            formEl.resetFields();
        };

        const submitForm = async (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            await formEl.validate((valid, fields) => {
                if (valid)
                    (gblAction.value == 'new') ? save() : update()
                  
            });
        };

        const save = () => {
            loader.value = true
            sportService.save(form)
            .then( (res) => {
                loader.value = false
                emit("onResponse", res.data)
            }).catch( ({response}) => {
                loader.value = false
                errManager(response)
            })
        }

        const onEdit = async () => {
            loader.value = true
            await sportService.edit(props.item.idsport)
            .then((res) => {
                loader.value = false
                Object.assign(form, res.data)
                if(res.data){
                    form.fnc = cBoolean(form.fnc)
                }
            }).catch(({response})=>{
                loader.value = false
                errManager(response)
            })
        }

        const update = () => {
            loader.value = true
            sportService.update(form.idsport, form)
            .then( (res) => {
                loader.value = false
                emit("onResponse", res.data)
            }).catch( ({response}) => {
                loader.value = false
                errManager(response)
            })
        }

        return {
            gblDialog,
            gblAction,
            titleDialog,
            ruleFormRef,
            loader,
            form,
            rules,
            listCategorie,
            listStatus,
            //event
            onOpen,
            onOpened,
            onClosed,
            onEdit,
            resetForm,
            submitForm,
            cBoolean

        }
    },
})
